import ComponentLayout from "../../../../src/layouts/component-layout";
import anatomy from "../../../../content/components/Breadcrumbs/images/anatomy.png";
import variants from "../../../../content/components/Breadcrumbs/images/variants.png";
import doOverflow from "../../../../content/components/Breadcrumbs/images/do-overflow.png";
import dontOverflow from "../../../../content/components/Breadcrumbs/images/dont-overflow.png";
import * as React from 'react';
export default {
  ComponentLayout,
  anatomy,
  variants,
  doOverflow,
  dontOverflow,
  React
};